$('.send-dpa-btn').click(function (event) {
    event.preventDefault();

    let form = $(this).closest('form');
    form.find('.alert-message').hide().removeClass('in');

    $.post(form.attr('action'), JSON.stringify({
        project: form.find('input[name=project]').val(),
        legalName: form.find('input[name=legal_name]').val(),          // Entity Legal Name
        name: form.find('input[name=name]').val(),                // Full Name
        capacity: form.find('input[name=capacity]').val(),        // Capacity / Title (new)
        email: form.find('input[name=email]').val(),
        gRecaptchaResponse: form.find('textarea[name=gRecaptchaResponse]').val(),
    }), 'json')
        .done(result => {
            form[0].reset();
            $('.modal').click();
            form.find('.alert-message').removeClass('in');

            setTimeout(() => {
                $('#form-modal-success').modal('show');
            }, 500);

            setTimeout(function () {
                $('#form-modal-success').modal('hide');
            }, 5000);
        })
        .fail((xhr, status, error) => {
            if (xhr.responseJSON && xhr.responseJSON.errors && xhr.responseJSON.errors.length) {
                xhr.responseJSON.errors.map((parseError) => {
                    if (parseError) {
                        form.find('.error-send-dpa-' + parseError.path).html(parseError.error).show().addClass('in');
                    }
                })
            }
        });
});